/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getPermissions } from "../../context/AuthContext";
import Pagination from "../../components/Pagination";
import { generalTermsListApi } from "../../services/_generalTerms";
import Spinner from "../../theme/Spinner";
import moment from "moment";
import { errorToast } from "../../components/Toast";
import ViewGeneralTerm from "./ViewGeneralTerm";
import { getProductNameListApi } from "../../services/_product";
import ReactSelect from "react-select";

const GeneralTermsList = () => {
  const permissions = getPermissions();
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [termId, setTermId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const [productList, setProductList] = useState([]);
  const [filterProductId, setFilterProductId] = useState<string>("");
  const productRef = useRef<any>(null);

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const getGeneralTermsList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (filterProductId) {
        query += `&product_id=${filterProductId}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
    }

    const result: any = await generalTermsListApi(query);

    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchProductNameSuggestions = async () => {
      const result: any = await getProductNameListApi();

      if (result.isSuccess) {
        setProductList(result?.data || []);
      } else {
        errorToast(result.message);
      }
    };
    fetchProductNameSuggestions();
  }, []);

  const filterList = async () => {
    setApplyFilter(true);

    getGeneralTermsList(page, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    setFilterProductId("");
    if (productRef.current) {
      productRef.current.clearValue();
    }

    getGeneralTermsList(page, perPage);
  };
  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getGeneralTermsList(page, perPage, true, key, type);
  };

  useEffect(() => {
    if (page && perPage) {
      getGeneralTermsList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>General Terms List</h5>
          </div>

          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            {permissions.includes("create-general-terms") && (
              <Link
                className="btn btn-primary waves-effect waves-light"
                type="button"
                to="/create-general-terms"
              >
                <span>
                  <i className="ti ti-plus me-sm-1"></i>{" "}
                  <span className="d-none d-sm-inline-block">
                    Add General Term
                  </span>
                </span>
              </Link>
            )}
          </div>
        </div>

        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Product:
                      </label>
                      {(() => {
                        const selectedOption = productList?.find(
                          (option: any) => option.id === filterProductId
                        );
                        const formatOptionLabel = (
                          option: any,
                          { context }: any
                        ) => {
                          if (context === "value") {
                            return option.name;
                          } else {
                            return (
                              <div>
                                <label className="form-label">
                                  {option.name}
                                </label>
                                <br />
                                <span className="form-label">
                                  {option.description}
                                </span>
                              </div>
                            );
                          }
                        };
                        return (
                          <ReactSelect
                            ref={productRef}
                            classNamePrefix="react-select"
                            placeholder="Select Product"
                            options={productList}
                            getOptionLabel={(option: any) => option.name}
                            formatOptionLabel={formatOptionLabel}
                            getOptionValue={(option: any) => option.id}
                            onChange={(selectedOption: any) => {
                              setFilterProductId(selectedOption?.id || "");
                            }}
                            value={selectedOption}
                            isClearable
                            isSearchable
                          />
                        );
                      })()}
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("product")}
                >
                  Product Name
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("term")}
                >
                  Term
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("created_at")}
                >
                  Created At
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                {permissions.includes("update-general-terms") && (
                  <th>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((item: any, i: number) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * perPage + 1 + i}</td>
                    <td>
                      {
                        <Link
                          to={"#"}
                          onClick={() => {
                            setTermId(item.id);
                          }}
                          title="View General Terms ProductDetails"
                          data-bs-toggle="modal"
                          data-bs-target="#viewGeneralTerm"
                        >
                          {item.product?.name || "N/A"}
                        </Link>
                      }
                    </td>

                    <td>{item.term}</td>
                    <td>
                      {moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}
                    </td>
                    {permissions.includes("update-general-terms") && (
                      <td>
                        <>
                          <Link
                            to={`/edit-general-terms/${item.id}`}
                            className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                            title="Edit General Terms"
                          >
                            <i className="ti ti-pencil ti-md"></i>
                          </Link>
                        </>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={
                      permissions.includes("update-general-terms") ? 6 : 4
                    }
                    className="text-center"
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />

        <ViewGeneralTerm termId={termId} />
      </div>
    </>
  );
};

export default GeneralTermsList;
